export function normalizeActionListResult<T>(response:any):{data:T[];total:number}{
  if(Array.isArray(response))return{data:response,total:response.length};
  if(!response||!Array.isArray(response.data)||!Number.isSafeInteger(response.total)||response.total<0)throw Error('Liste yanıtı doğrulanamadı.');return response;
}
